"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8683],{

/***/ 48683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46066);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6154);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31955);





const MainSlider = (props)=>{
    const [imageSources, setImageSources] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [sliderItems, setSliderItems] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    let NCRcities = [
        "Delhi",
        "Gurugram",
        "Faridabad",
        "Noida",
        "Ghaziabad",
        "Greater Noida",
        "Meerut",
        "Sonipat",
        "Panipat",
        "Rohtak",
        "Karnal",
        "Bhiwani",
        "Rewari",
        "Palwal",
        "Jind",
        "Alwar",
        "Bharatpur",
        "Bulandshahr",
        "Bhiwadi",
        "Muzaffarnagar",
        "Shamli",
        "Baghpat",
        "Hapur",
        "New Delhi",
        "Dādri"
    ];
    let addDelhiBanner = async (arr)=>{
        if (js_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("delhiNCR")) {
            let sources = [];
            // COMMENTING DELHI BANNER LOGIC on April 4 2025 as asked by Jitender. DO NOT REMOVE IT
            // sources.push({
            //   src: "/delhi_banner.avif",
            //   href: "/tiles/delhi?utm_source=google&utm_medium=organic&utm_campaign=Website_banner_delhi&utm_term=Tiles_in_Delhi",
            // });
            sources = sources.concat(arr);
            setImageSources(sources);
        } else {
            let ipInfo = await axios__WEBPACK_IMPORTED_MODULE_4__/* ["default"].get */ .Z.get("https://obl-js.orientbell.com/api/ipinfo");
            if (ipInfo.status == 200) {
                var ref;
                let sources1 = [];
                if (NCRcities.includes((ref = ipInfo.data.response) === null || ref === void 0 ? void 0 : ref.city)) {
                    sources1.push({
                        src: "/delhi_banner.avif",
                        href: "/tiles/delhi?utm_source=google&utm_medium=organic&utm_campaign=Website_banner_delhi&utm_term=Tiles_in_Delhi"
                    });
                    js_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"].set */ .Z.set("delhiNCR", true);
                }
                sources1 = sources1.concat(arr);
                setImageSources(sources1);
            } else {
                setImageSources(arr);
            }
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const html = props.data;
        const tempElement1 = document.createElement("div");
        tempElement1.innerHTML = html;
        const aElements = tempElement1.getElementsByTagName("a");
        let sources = [];
        // if (NCRcities.includes(props.city?.city)) {
        //   sources.push({
        //     src: "/delhi_banner.jpeg",
        //     href: "/tiles/delhi",
        //   });
        // }
        sources = sources.concat(Array.from(aElements).map((a)=>{
            const img = a.querySelector("img");
            return {
                src: img ? img.getAttribute("src") : null,
                href: a.getAttribute("href")
            };
        }).filter((source)=>source.src !== null)); // Ensure we only include valid images
        // setImageSources(sources);
        addDelhiBanner(sources);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const itemsPerRow = 1; // Number of items per row
        const rows = Math.ceil(imageSources.length / itemsPerRow);
        const newSliderItems = [];
        let startIndex = 0;
        for(let i = 0; i < rows; i++){
            const endIndex = startIndex + itemsPerRow;
            const rowImages = imageSources.slice(startIndex, endIndex);
            const rowItems = rowImages.map((cur, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "styletiles-bx-item",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "styletiles-bx",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: cur.href,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: cur.src,
                                    alt: "banner image"
                                })
                            })
                        }),
                        " "
                    ]
                }, index));
            newSliderItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: rowItems
            }, i));
            startIndex += itemsPerRow;
        }
        setSliderItems(newSliderItems);
    }, [
        imageSources
    ]);
    const settings = {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        centerMode: true,
        autoplaySpeed: 5000,
        arrows: true,
        dots: false,
        centerPadding: "0px"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "home_style style-tiles-section",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                ...settings,
                className: "category-menu",
                children: sliderItems
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (MainSlider);


/***/ })

}]);